import { render, staticRenderFns } from "./BasicBarGraph.vue?vue&type=template&id=27f3ef98"
import script from "./BasicBarGraph.vue?vue&type=script&lang=js"
export * from "./BasicBarGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports